// // export default Competitors;
// import React, { useState, useRef, useEffect } from 'react';
// import { useGoogleMaps } from '../../hooks/useGoogleMaps';
// import { normalizeBrandName } from '../../utils/normalizeBrandName';

// const avatarColors = ['#E05C4B', '#0D9488', '#1A73E8', '#C47D1A', '#8B4FA0'];

// const initials = (name) =>
//   name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();

// // ── Inline Places search for competitor edit row ──────────────────────────
// const CompetitorSearchInput = ({ value, onChange, onPlaceSelected }) => {
//   const [suggestions, setSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [isLoadingPlace, setIsLoadingPlace] = useState(false);
//   const autocompleteService = useRef(null);
//   const placesService = useRef(null);
//   const mapDivRef = useRef(null);
//   const { isLoaded } = useGoogleMaps();

//   useEffect(() => {
//     if (!isLoaded) return;
//     autocompleteService.current = new window.google.maps.places.AutocompleteService();
//     mapDivRef.current = document.createElement('div');
//     placesService.current = new window.google.maps.places.PlacesService(mapDivRef.current);
//   }, [isLoaded]);

//   const handleChange = (e) => {
//     const val = e.target.value;
//     onChange(val);

//     if (!autocompleteService.current || val.length < 2) {
//       setSuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }

//     autocompleteService.current.getPlacePredictions(
//       { input: val, types: ['establishment'] },
//       (predictions, status) => {
//         if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
//           setSuggestions(predictions);
//           setShowSuggestions(true);
//         } else {
//           setSuggestions([]);
//           setShowSuggestions(false);
//         }
//       }
//     );
//   };

//   const selectPrediction = (prediction) => {
//     setSuggestions([]);
//     setShowSuggestions(false);
//     onChange(prediction.structured_formatting.main_text);

//     if (!placesService.current) return;
//     setIsLoadingPlace(true);

//     placesService.current.getDetails(
//       {
//         placeId: prediction.place_id,
//         fields: [
//           'name', 'website', 'formatted_address',
//           'rating', 'user_ratings_total',
//           'international_phone_number', 'place_id',
//           'address_components',
//         ],
//       },
//       (place, status) => {
//         setIsLoadingPlace(false);
//         if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) return;

//         const components = place.address_components || [];
//         const cityComp =
//           components.find(c => c.types.includes('locality')) ||
//           components.find(c => c.types.includes('administrative_area_level_2')) ||
//           components.find(c => c.types.includes('administrative_area_level_1'));
//         const city = cityComp?.long_name || '';

//         onPlaceSelected({
//           name:    normalizeBrandName(place.name || prediction.structured_formatting.main_text),
//           website: place.website || '',
//           rating:  place.rating || 0,
//           reviews: place.user_ratings_total || 0,
//           placeId: place.place_id || prediction.place_id,
//           address: place.formatted_address || '',
//           city,
//         });
//       }
//     );
//   };

//   return (
//     <div style={{ position: 'relative' }}>
//       <input
//         className="cedit-in"
//         value={value}
//         onChange={handleChange}
//         onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
//         placeholder="Search business name…"
//         autoFocus
//         autoComplete="off"
//       />

//       {isLoadingPlace && (
//         <div style={{
//           position: 'absolute', right: 10, top: '50%',
//           transform: 'translateY(-50%)',
//           fontSize: 11, color: 'var(--muted)',
//         }}>
//           Fetching…
//         </div>
//       )}

//       {showSuggestions && suggestions.length > 0 && (
//         <div style={{
//           position: 'absolute',
//           top: '100%',
//           left: 0, right: 0,
//           background: '#fff',
//           border: '1.5px solid var(--bi)',
//           borderRadius: 10,
//           boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
//           zIndex: 999,
//           maxHeight: 220,
//           overflowY: 'auto',
//         }}>
//           {suggestions.map(pred => (
//             <div
//               key={pred.place_id}
//               onMouseDown={(e) => { e.preventDefault(); selectPrediction(pred); }}
//               style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: 2,
//                 padding: '10px 14px',
//                 cursor: 'pointer',
//                 borderBottom: '1px solid var(--bi)',
//                 transition: 'background 0.15s',
//               }}
//               onMouseEnter={e => e.currentTarget.style.background = '#f7f5ff'}
//               onMouseLeave={e => e.currentTarget.style.background = '#fff'}
//             >
//               <span style={{ fontWeight: 500, fontSize: 14, color: 'var(--text)' }}>
//                 {pred.structured_formatting.main_text}
//               </span>
//               <small style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.3 }}>
//                 {pred.structured_formatting.secondary_text}
//               </small>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // ── Main Competitors component ────────────────────────────────────────────
// const Competitors = ({ competitors, isLoading, onConfirm, onUpdateCompetitors, auditLoading }) => {
//   const [editId, setEditId] = useState(null);
//   const [editData, setEditData] = useState({});

//   const startEdit = (comp) => {
//     setEditId(comp.id);
//     setEditData({ ...comp });
//   };

//   const saveEdit = () => {
//     const updated = competitors.map(c => (c.id === editId ? { ...editData } : c));
//     onUpdateCompetitors(updated);
//     setEditId(null);
//   };

//   const cancelEdit = () => setEditId(null);

//   const removeCompetitor = (id) => {
//     onUpdateCompetitors(competitors.filter(c => c.id !== id));
//   };

//   const addCompetitor = () => {
//     if (competitors.length >= 5) return;
//     const newComp = {
//       id: Date.now(),
//       name: '',
//       website: '',
//       rating: 0,
//       reviews: 0,
//       isManual: true,
//     };
//     onUpdateCompetitors([...competitors, newComp]);
//     startEdit(newComp);
//   };

//   const handlePlaceSelected = (placeData) => {
//     setEditData(prev => ({
//       ...prev,
//       name:    placeData.name,
//       website: placeData.website,
//       rating:  placeData.rating,
//       reviews: placeData.reviews,
//       placeId: placeData.placeId,
//       address: placeData.address,
//       city:    placeData.city,
//     }));
//   };

//   return (
//     <div className="card" id="card-3" style={{ padding: 5, overflow: 'hidden', borderRadius: '15px' }}>
//       <h2 className="ctitle">Competitors in your space</h2>
//       <p className="cdesc">
//         Competitors identified based on your market presence. Edit, remove, or add name, upto 5
//       </p>

//       {isLoading && (
//         <div className="comp-fetch show">
//           <div className="spinner" />
//           <span>Finding top competitors in your space…</span>
//         </div>
//       )}

//       {!isLoading && (
//         <>
//           <div className="comp-list show">
//             {competitors.length === 0 && (
//               <div style={{
//                 padding: '24px', textAlign: 'center',
//                 color: 'var(--muted)', fontSize: 14,
//                 border: '1.5px dashed var(--bi)',
//                 borderRadius: 12, marginBottom: 12,
//               }}>
//                 No competitors added yet. Click "Add a competitor" below.
//               </div>
//             )}

//             {competitors.map((comp, idx) => {
//               const color = avatarColors[idx % avatarColors.length];
//               const isEditing = editId === comp.id;
//               const displayName = comp.name || comp.website || 'New Competitor';

//               // FIX 3: true only for a brand-new row (isManual + no name yet)
//               const isNewEntry = comp.isManual && !comp.name?.trim();

//               if (isEditing) {
//                 return (
//                   <div key={comp.id} className="comp-edit-row show">
//                     <div className="comp-edit-grid">

//                       {/* Business Name — always editable */}
//                       <div className="full">
//                         <div className="cedit-lbl">
//                           Business Name
//                           <span style={{
//                             fontSize: 10, color: 'var(--thistle)',
//                             marginLeft: 6, fontWeight: 400,
//                           }}>
//                             — search to auto-fill details
//                           </span>
//                         </div>
//                         <CompetitorSearchInput
//                           value={editData.name || ''}
//                           onChange={(val) => setEditData(prev => ({ ...prev, name: val }))}
//                           onPlaceSelected={handlePlaceSelected}
//                         />
//                       </div>

//                       {/* FIX 3 (new) + FIX (edit existing): Website — disabled for new entry, readOnly for existing */}
//                       <div className="full">
//                         <div className="cedit-lbl">
//                           Website URL
//                           {editData.website && (
//                             <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>
//                               ✓ Auto-filled
//                             </span>
//                           )}
//                         </div>
//                         <input
//                           className="cedit-in"
//                           value={editData.website || ''}
//                           placeholder="https://apexdigital.com"
//                           disabled={isNewEntry}
//                           readOnly={!isNewEntry}
//                           style={{
//                             opacity: isNewEntry ? 0.4 : 0.6,
//                             cursor: 'default',
//                             background: '#f7f7fb',
//                           }}
//                         />
//                       </div>

//                       {/* FIX 3 (new) + FIX (edit existing): Star Rating — disabled for new, readOnly for existing */}
//                       <div>
//                         <div className="cedit-lbl">
//                           Star Rating
//                           {editData.rating > 0 && (
//                             <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>
//                               ✓ Auto-filled
//                             </span>
//                           )}
//                         </div>
//                         <input
//                           className="cedit-in"
//                           type="number"
//                           step="0.1"
//                           min="1"
//                           max="5"
//                           value={editData.rating || ''}
//                           placeholder="e.g. 4.5"
//                           disabled={isNewEntry}
//                           readOnly={!isNewEntry}
//                           style={{
//                             opacity: isNewEntry ? 0.4 : 0.6,
//                             cursor: 'default',
//                             background: '#f7f7fb',
//                           }}
//                         />
//                       </div>

//                       {/* FIX 3 (new) + FIX (edit existing): Total Reviews — disabled for new, readOnly for existing */}
//                       <div>
//                         <div className="cedit-lbl">
//                           Total Reviews
//                           {editData.reviews > 0 && (
//                             <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>
//                               ✓ Auto-filled
//                             </span>
//                           )}
//                         </div>
//                         <input
//                           className="cedit-in"
//                           type="number"
//                           value={editData.reviews || ''}
//                           placeholder="e.g. 120"
//                           disabled={isNewEntry}
//                           readOnly={!isNewEntry}
//                           style={{
//                             opacity: isNewEntry ? 0.4 : 0.6,
//                             cursor: 'default',
//                             background: '#f7f7fb',
//                           }}
//                         />
//                       </div>

//                       {/* Address — always read-only display */}
//                       {editData.address && (
//                         <div className="full">
//                           <div className="cedit-lbl">
//                             Address
//                             <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>✓ Auto-filled</span>
//                           </div>
//                           <div style={{
//                             fontSize: 12, color: 'var(--muted)',
//                             padding: '8px 12px',
//                             background: '#f7f7fb',
//                             borderRadius: 8,
//                             border: '1.5px solid var(--bi)',
//                             lineHeight: 1.4,
//                           }}>
//                             {editData.address}
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     <div className="edit-actions">
//                       <button
//                         className="edit-save"
//                         onClick={saveEdit}
//                         disabled={!editData.name?.trim()}
//                       >
//                         Save changes
//                       </button>
//                       <button className="edit-cancel" onClick={cancelEdit}>Cancel</button>
//                     </div>
//                   </div>
//                 );
//               }

//               // ── Display row ──────────────────────────────────────
//               return (
//                 <div key={comp.id} className="comp-row">
//                   <div className="comp-avatar" style={{ background: color }}>
//                     {initials(displayName)}
//                   </div>
//                   <div className="comp-info">
//                     <div className="comp-name-row">
//                       <span className="comp-name">{displayName}</span>
//                       {comp.isManual && (
//                         <span style={{
//                           fontSize: 10, fontWeight: 500,
//                           background: 'rgba(107,79,160,.1)',
//                           color: 'var(--thistle)',
//                           padding: '2px 8px', borderRadius: 8, marginLeft: 6,
//                         }}>
//                           Added by you
//                         </span>
//                       )}
//                     </div>

//                     {/* FIX 2: Line 1 — website only */}
//                     <div className="comp-meta">
//                       {comp.website && (
//                         <a className="comp-site" href={comp.website} target="_blank" rel="noopener noreferrer">
//                           <svg viewBox="0 0 24 24" width="12" height="12">
//                             <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="currentColor"/>
//                           </svg>
//                           {comp.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
//                         </a>
//                       )}
//                     </div>

//                     {/* FIX 2: Line 2 — rating + reviews + city always here */}
//                     <div className="comp-meta" style={{ marginTop: 2 }}>
//                       {comp.rating > 0 && (
//                         <span className="comp-rating">
//                           <span className="star">★</span>
//                           {Number(comp.rating).toFixed(1)}
//                         </span>
//                       )}
//                       {comp.reviews > 0 && (
//                         <>
//                           <span className="comp-divider" />
//                           <span className="comp-reviews">{comp.reviews} reviews</span>
//                         </>
//                       )}
//                       {comp.address && (
//                         <>
//                           <span className="comp-divider" />
//                           <span style={{ fontSize: 11, color: 'var(--muted)' }}>
//                             {comp.city || comp.address?.split(',')[0]}
//                           </span>
//                         </>
//                       )}
//                     </div>
//                   </div>

//                   <div className="comp-actions">
//                     <button className="comp-act edit" onClick={() => startEdit(comp)} title="Edit">
//                       <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
//                         <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
//                       </svg>
//                     </button>
//                     <button className="comp-act del" onClick={() => removeCompetitor(comp.id)} title="Remove">
//                       <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
//                         <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* FIX 1: Add competitor / max reached CTA */}
//           {competitors.length < 5 ? (
//             <button className="add-comp-btn" onClick={addCompetitor} disabled={auditLoading}>
//               <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
//               </svg>
//               Add a competitor
//             </button>
//           ) : (
//             <div className="add-comp-btn add-comp-btn--max">
//               Maximum 5 competitors reached
//             </div>
//           )}

//           {/* Continue button */}
//           <button
//             className="btn"
//             onClick={onConfirm}
//             disabled={competitors.length === 0 || auditLoading}
//             style={{ marginTop: 12, opacity: auditLoading ? 0.7 : 1 }}
//           >
//             {auditLoading ? (
//               <>
//                 <div className="spinner" style={{
//                   width: 16, height: 16, borderWidth: 2,
//                   display: 'inline-block', marginRight: 8, verticalAlign: 'middle',
//                 }} />
//                 Running audit…
//               </>
//             ) : (
//               <>
//                 Explore Detailed Insights
//                 <svg viewBox="0 0 24 24" fill="white" width="18" height="18">
//                   <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
//                 </svg>
//               </>
//             )}
//           </button>
//         </>
//       )}
//     </div>
//   );
// };

// export default Competitors;

import React, { useState, useRef, useEffect } from 'react';
import { useGoogleMaps } from '../../hooks/useGoogleMaps';
import { normalizeBrandName } from '../../utils/normalizeBrandName';

const avatarColors = ['#E05C4B', '#0D9488', '#1A73E8', '#C47D1A', '#8B4FA0'];
const initials = (name) =>
  name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();

// ── helper: extract city from a formatted address string ─────────────────
const extractCity = (address = '') => {
  const parts = address.split(',');
  // Usually: "Street, Area, City, State, Country"
  // City is typically the 3rd or 2nd-to-last meaningful part
  return parts.length >= 2 ? parts[parts.length - 3]?.trim() || parts[0].trim() : parts[0]?.trim() || '';
};

// ── helper: normalize a raw competitor from backend or Google pick ────────
const normalizeCompetitor = (raw) => ({
  id:                 raw.id ?? raw.place_id ?? Date.now(),
  name:               raw.name || '',
  website:            raw.website || null,
  address:            raw.address || null,
  rating:             raw.rating ?? 0,
  // backend key is user_ratings_total; Google pick uses reviews
  user_ratings_total: raw.user_ratings_total ?? raw.reviews ?? 0,
  place_id:           raw.place_id ?? raw.placeId ?? null,
  isManual:           raw.isManual ?? false,
});

// ── Inline Places search for competitor edit row ──────────────────────────
const CompetitorSearchInput = ({ value, onChange, onPlaceSelected }) => {
  const [suggestions, setSuggestions]   = useState([]);
  const [showSuggestions, setShow]      = useState(false);
  const [isLoadingPlace, setLoading]    = useState(false);
  const autocompleteService             = useRef(null);
  const placesService                   = useRef(null);
  const mapDivRef                       = useRef(null);
  const { isLoaded }                    = useGoogleMaps();

  useEffect(() => {
    if (!isLoaded) return;
    autocompleteService.current = new window.google.maps.places.AutocompleteService();
    mapDivRef.current = document.createElement('div');
    placesService.current = new window.google.maps.places.PlacesService(mapDivRef.current);
  }, [isLoaded]);

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);
    if (!autocompleteService.current || val.length < 2) {
      setSuggestions([]); setShow(false); return;
    }
    autocompleteService.current.getPlacePredictions(
      { input: val, types: ['establishment'] },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          setSuggestions(predictions); setShow(true);
        } else {
          setSuggestions([]); setShow(false);
        }
      }
    );
  };

  const selectPrediction = (prediction) => {
    setSuggestions([]); setShow(false);
    onChange(prediction.structured_formatting.main_text);
    if (!placesService.current) return;
    setLoading(true);
    placesService.current.getDetails(
      {
        placeId: prediction.place_id,
        fields: [
          'name', 'website', 'formatted_address',
          'rating', 'user_ratings_total', 'place_id',
        ],
      },
      (place, status) => {
        setLoading(false);
        if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) return;

        // ── emit shape matching normalizeCompetitor ───────────────────────
        onPlaceSelected({
          name:               normalizeBrandName(place.name || prediction.structured_formatting.main_text),
          website:            place.website || null,
          rating:             place.rating ?? 0,
          user_ratings_total: place.user_ratings_total ?? 0,   // ← correct key
          place_id:           place.place_id || prediction.place_id,
          address:            place.formatted_address || '',
        });
      }
    );
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        className="cedit-in"
        value={value}
        onChange={handleChange}
        onBlur={() => setTimeout(() => setShow(false), 150)}
        placeholder="Search business name…"
        autoFocus
        autoComplete="off"
      />
      {isLoadingPlace && (
        <div style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', fontSize: 11, color: 'var(--muted)' }}>
          Fetching…
        </div>
      )}
      {showSuggestions && suggestions.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: '#fff', border: '1.5px solid var(--bi)',
          borderRadius: 10, boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
          zIndex: 999, maxHeight: 220, overflowY: 'auto',
        }}>
          {suggestions.map(pred => (
            <div
              key={pred.place_id}
              onMouseDown={(e) => { e.preventDefault(); selectPrediction(pred); }}
              style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '10px 14px', cursor: 'pointer', borderBottom: '1px solid var(--bi)', transition: 'background 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f7f5ff'}
              onMouseLeave={e => e.currentTarget.style.background = '#fff'}
            >
              <span style={{ fontWeight: 500, fontSize: 14, color: 'var(--text)' }}>
                {pred.structured_formatting.main_text}
              </span>
              <small style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.3 }}>
                {pred.structured_formatting.secondary_text}
              </small>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ── Main component ────────────────────────────────────────────────────────
const Competitors = ({ competitors: rawCompetitors, isLoading, onConfirm, onUpdateCompetitors, auditLoading }) => {

  // Normalize on the way in so the rest of the component uses consistent keys
  const competitors = (rawCompetitors || []).map(normalizeCompetitor);

  const [editId,   setEditId]   = useState(null);
  const [editData, setEditData] = useState({});

  const startEdit = (comp) => { setEditId(comp.id); setEditData({ ...comp }); };
  const cancelEdit = () => setEditId(null);

  const saveEdit = () => {
    const updated = competitors.map(c => c.id === editId ? { ...normalizeCompetitor(editData) } : c);
    onUpdateCompetitors(updated);
    setEditId(null);
  };

  const removeCompetitor = (id) => onUpdateCompetitors(competitors.filter(c => c.id !== id));

  const addCompetitor = () => {
    if (competitors.length >= 5) return;
    const newComp = normalizeCompetitor({ id: Date.now(), name: '', isManual: true });
    onUpdateCompetitors([...competitors, newComp]);
    startEdit(newComp);
  };

  const handlePlaceSelected = (placeData) => {
    setEditData(prev => ({ ...prev, ...normalizeCompetitor({ ...prev, ...placeData }) }));
  };

  return (
    <div className="card" id="card-3" style={{ padding: 5, overflow: 'hidden', borderRadius: '15px' }}>
      <h2 className="ctitle">Competitors in your space</h2>
      <p className="cdesc">Competitors identified based on your market presence. Edit, remove, or add — up to 5.</p>

      {isLoading && (
        <div className="comp-fetch show">
          <div className="spinner" />
          <span>Finding top competitors in your space…</span>
        </div>
      )}

      {!isLoading && (
        <>
          <div className="comp-list show">
            {competitors.length === 0 && (
              <div style={{ padding: '24px', textAlign: 'center', color: 'var(--muted)', fontSize: 14, border: '1.5px dashed var(--bi)', borderRadius: 12, marginBottom: 12 }}>
                No competitors added yet. Click "Add a competitor" below.
              </div>
            )}

            {competitors.map((comp, idx) => {
              const color       = avatarColors[idx % avatarColors.length];
              const isEditing   = editId === comp.id;
              const displayName = comp.name || comp.website || 'New Competitor';
              const isNewEntry  = comp.isManual && !comp.name?.trim();

              if (isEditing) {
                return (
                  <div key={comp.id} className="comp-edit-row show">
                    <div className="comp-edit-grid">

                      <div className="full">
                        <div className="cedit-lbl">
                          Business Name
                          <span style={{ fontSize: 10, color: 'var(--thistle)', marginLeft: 6, fontWeight: 400 }}>
                            — search to auto-fill details
                          </span>
                        </div>
                        <CompetitorSearchInput
                          value={editData.name || ''}
                          onChange={(val) => setEditData(prev => ({ ...prev, name: val }))}
                          onPlaceSelected={handlePlaceSelected}
                        />
                      </div>

                      <div className="full">
                        <div className="cedit-lbl">
                          Website URL
                          {editData.website && <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>✓ Auto-filled</span>}
                        </div>
                        <input className="cedit-in" value={editData.website || ''} placeholder="https://example.com"
                          disabled={isNewEntry} readOnly={!isNewEntry}
                          style={{ opacity: isNewEntry ? 0.4 : 0.6, cursor: 'default', background: '#f7f7fb' }}
                        />
                      </div>

                      <div>
                        <div className="cedit-lbl">
                          Star Rating
                          {editData.rating > 0 && <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>✓ Auto-filled</span>}
                        </div>
                        <input className="cedit-in" type="number" step="0.1" min="1" max="5"
                          value={editData.rating || ''} placeholder="e.g. 4.5"
                          disabled={isNewEntry} readOnly={!isNewEntry}
                          style={{ opacity: isNewEntry ? 0.4 : 0.6, cursor: 'default', background: '#f7f7fb' }}
                        />
                      </div>

                      <div>
                        <div className="cedit-lbl">
                          Total Reviews
                          {/* ── fixed: user_ratings_total ── */}
                          {editData.user_ratings_total > 0 && <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>✓ Auto-filled</span>}
                        </div>
                        <input className="cedit-in" type="number"
                          value={editData.user_ratings_total || ''} placeholder="e.g. 120"
                          disabled={isNewEntry} readOnly={!isNewEntry}
                          style={{ opacity: isNewEntry ? 0.4 : 0.6, cursor: 'default', background: '#f7f7fb' }}
                        />
                      </div>

                      {editData.address && (
                        <div className="full">
                          <div className="cedit-lbl">Address <span style={{ fontSize: 10, color: '#0D9488', marginLeft: 6 }}>✓ Auto-filled</span></div>
                          <div style={{ fontSize: 12, color: 'var(--muted)', padding: '8px 12px', background: '#f7f7fb', borderRadius: 8, border: '1.5px solid var(--bi)', lineHeight: 1.4 }}>
                            {editData.address}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="edit-actions">
                      <button className="edit-save" onClick={saveEdit} disabled={!editData.name?.trim()}>Save changes</button>
                      <button className="edit-cancel" onClick={cancelEdit}>Cancel</button>
                    </div>
                  </div>
                );
              }

              // ── Display row ───────────────────────────────────────────
              return (
                <div key={comp.id} className="comp-row">
                  <div className="comp-avatar" style={{ background: color }}>{initials(displayName)}</div>

                  <div className="comp-info">
                    <div className="comp-name-row">
                      <span className="comp-name">{displayName}</span>
                      {comp.isManual && (
                        <span style={{ fontSize: 10, fontWeight: 500, background: 'rgba(107,79,160,.1)', color: 'var(--thistle)', padding: '2px 8px', borderRadius: 8, marginLeft: 6 }}>
                          Added by you
                        </span>
                      )}
                    </div>

                    {/* Line 1 — website */}
                    {comp.website && (
                      <div className="comp-meta">
                        <a className="comp-site" href={comp.website} target="_blank" rel="noopener noreferrer">
                          <svg viewBox="0 0 24 24" width="12" height="12"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="currentColor"/></svg>
                          {comp.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
                        </a>
                      </div>
                    )}

                    {/* Line 2 — rating + reviews + city (extracted from address) */}
                    <div className="comp-meta" style={{ marginTop: 2 }}>
                      {comp.rating > 0 && (
                        <span className="comp-rating"><span className="star">★</span>{Number(comp.rating).toFixed(1)}</span>
                      )}
                      {/* ── fixed: user_ratings_total ── */}
                      {comp.user_ratings_total > 0 && (
                        <>
                          <span className="comp-divider" />
                          <span className="comp-reviews">{comp.user_ratings_total.toLocaleString()} reviews</span>
                        </>
                      )}
                      {comp.address && (
                        <>
                          <span className="comp-divider" />
                          <span style={{ fontSize: 11, color: 'var(--muted)' }}>
                            {extractCity(comp.address)}
                          </span>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="comp-actions">
                    <button className="comp-act edit" onClick={() => startEdit(comp)} title="Edit">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                    </button>
                    <button className="comp-act del" onClick={() => removeCompetitor(comp.id)} title="Remove">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {competitors.length < 5 ? (
            <button className="add-comp-btn" onClick={addCompetitor} disabled={auditLoading}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
              Add a competitor
            </button>
          ) : (
            <div className="add-comp-btn add-comp-btn--max">Maximum 5 competitors reached</div>
          )}

          <button className="btn" onClick={onConfirm} disabled={competitors.length === 0 || auditLoading}
            style={{ marginTop: 12, opacity: auditLoading ? 0.7 : 1 }}>
            {auditLoading ? (
              <><div className="spinner" style={{ width: 16, height: 16, borderWidth: 2, display: 'inline-block', marginRight: 8, verticalAlign: 'middle' }} />Running audit…</>
            ) : (
              <>Continue to Scoring<svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/></svg></>
            )}
          </button>
        </>
      )}
    </div>
  );
};

export default Competitors;